module.exports = __webpack_public_path__ + "img/24.6d14094.png";